export class TransportesViagensModel {
  id_viagem: number;
  id_transporte: number = 0;
  id_local_carregamento: number = 0;
  id_local_descarga: number = 0;
  data_carregamento: string;
  data_descarga: string;
  eta: string;
}



// WEBPACK FOOTER //
// ./src/app/transportes-viagens/transportes-viagens.model.ts